import React, { useEffect } from "react";
import { EventType } from "../commons/Constants";
import useEventTrigger from "../commons/useEventTrigger";

const window = global.window as any;

export const SkenzoLander = () => {
  const fireEvent = useEventTrigger(EventType.SKENZO_VISIT);

  useEffect(() => {
    // adapted from https://godaddy-corp.atlassian.net/browse/PARKING-4283?focusedCommentId=7009811

    window._pQKdqgoh = window._pQKdqgoh || {};
    window._pQKdqgoh.queue = window._pQKdqgoh.queue || [];
    window.dm_versionId = "3121199";

    const script = document.createElement("script");
    script.src = "https://kwdsrv.com/dm.js?cid=8CU5RSJ5I";
    script.async = true;
    script.onload = () => {
      window._pQKdqgoh.queue.push(function () {
        window._pQGhwdlov.loadTag("286474553", "1154x689", "286474553");
      });
      fireEvent();
    };

    document.body.appendChild(script);

    // Cleanup
    return () => {
      document.body.removeChild(script);
    };
  }, [fireEvent]);

  return (
    <div
      id="286474553"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        width: "100%",
        overflow: "hidden",
      }}
    ></div>
  );
};
